import { Component, OnInit, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AuthService } from 'src/app/services/auth.service';
import { ShoppingService } from 'src/app/services/shopping.service';
import { StorageService } from 'src/app/services/storage.service';
import { filter, pluck } from 'rxjs';
import { LoginModalComponent } from 'src/app/modals/login-modal/login-modal.component';

@Component({
  selector: 'app-card-ticket',
  templateUrl: './card-ticket.component.html',
  styleUrls: ['./card-ticket.component.scss'],
})
export class CardTicketComponent implements OnInit {
  @Input() product: any;

  productShopping!: any;
  userLogin: boolean = false;
  viewCart!: any;
  quantityAccept: any = 10;
  quantityTicket: any = 0;

  constructor(
    private shopping: ShoppingService,
    public authService: AuthService,
    private storageService: StorageService,
    public modal: MatDialog
  ) {}

  async ngOnInit(): Promise<void> {
    await this.authService.getLoginStatus().subscribe((status: boolean) => {
      this.userLogin = status;
    });

    this.viewCart = this.shopping.getShoppingCart();

    this.productShopping = this.viewCart.find(
      (product: any) => product.uid === this.product.uid
    );

    const viewCart$ = this.storageService.storageChange$.pipe(
      filter(({ storageArea }) => storageArea === 'sessionStorage'),
      filter(({ key }) => key === 'shoppingCart'),
      pluck('value')
    );

    viewCart$.subscribe((value) => {
      this.viewCart = JSON.parse(value);
      this.productShopping = this.viewCart.find(
        (product: any) => product.uid === this.product.uid
      );
    });
  }

  removeProduct(product: any) {
    this.shopping.removeProduct(product);
    this.quantityTicket -= 1;
  }

  reduceProduct(product: any) {
    this.shopping.reduceProduct(product);
    this.quantityTicket -= 1;
  }
  addProduct(product: any) {
    //  animate__bounce animate__delay-2s animate__repeat-2

    if (this.userLogin) {
      this.shopping.addProduct(product);
      this.quantityTicket += 1;
      let element = document!.getElementById('checkoutButtonFloat')!;

      element.classList.add('animate__animated');
      element.classList.add('animate__bounceIn');

      setTimeout(() => {
        element.classList.remove('animate__animated');
        element.classList.remove('animate__bounceIn');
      }, 1000);
    } else {
      const dialogRef = this.modal.open(LoginModalComponent, {
        data: {},
        disableClose: true,
        // width: '100vw',
      });

      dialogRef.afterClosed().subscribe(async (result) => {
        if (result) {
        }
      });
    }
  }
}
